<template>
    <div class="action-item" @click="changeBrightness" :class="{active: $store.state.core.featuresStatus.brightness === 1 || $store.state.core.featuresStatus.brightness === 2}">
        <div class="active-action item" v-if="brightnessIndex > 0">
          <span class="icon-check"></span>
        </div>


        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                  <div v-html="brightnessLevel[$store.state.core.featuresStatus.brightness].icon"></div>
                  <h3>{{brightnessLevel[$store.state.core.featuresStatus.brightness].name}}</h3>
                </div>
            </template>
            <span>{{$t('Change website colors')}}</span>
        </v-tooltip>

        <v-style v-if="$store.state.core.featuresStatus.brightness===1">

            @media screen and (-webkit-min-device-pixel-ratio:0) {
            html {
            filter: invert(100%);
            -webkit-filter: invert(100%);
            }
            }
            @supports (-ms-ime-align: auto) {
            html {
            filter: invert(100%);
            -webkit-filter: invert(100%);
            }
            }
            @-moz-document url-prefix() {
                html {
                    filter: none !important;
                }
                p , img , h1 , h2 , h3 ,h4 , h5 ,h6 , span , input , label {
                    filter: invert(100%);
                    -webkit-filter: invert(100%);
                }
            }
        </v-style>
        <v-style v-if="$store.state.core.featuresStatus.brightness === 2">

            @media screen and (-webkit-min-device-pixel-ratio:0) {
            html {
            filter:gray; /* IE6-9 */
            -webkit-filter:grayscale(100%); /* Chrome 19+, Safari 6+, Safari 6+ iOS */
            -moz-filter: grayscale(100%);
            -o-filter: grayscale(100%);}
            }
            }
            @supports (-ms-ime-align: auto) {
            html {
            filter:gray; /* IE6-9 */
            -webkit-filter:grayscale(100%); /* Chrome 19+, Safari 6+, Safari 6+ iOS */
            -moz-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            }
            }
            @-moz-document url-prefix() {
                html {
                filter: none !important;
                -webkit-filter: none !important;
                -moz-filter: none !important;
                -o-filter: none !important;
                }

                p , img , h1 , h2 , h3 ,h4 , h5 ,h6 , span , input , label {
                    filter:gray; /* IE6-9 */
                    -webkit-filter:grayscale(100%); /* Chrome 19+, Safari 6+, Safari 6+ iOS */
                    -moz-filter: grayscale(100%);
                    -o-filter: grayscale(100%);
                }
            }
        </v-style>
        <div class="feature-progress d-flex">
            <div
                v-for="(i,index) in 2"
                :key="index"
                class="item-progress"
                :class="{primary: i <= $store.state.core.featuresStatus.brightness}"
            >
            </div>
        </div>
    </div>
</template>

<script>
    import {icons} from '../../utils/icons'
    export default {
        name: "brightness",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data() {
            return {
                selectedBrightness: {},
                brightnessIndex: 0
            }
        },
        mounted() {
            this.selectedBrightness = this.brightnessLevel [0]
        },
        methods: {
            changeBrightness() {
                if (this.$store.state.core.featuresStatus.brightness < 2) {
                    this.$store.state.core.featuresStatus.brightness++
                } else {
                    this.$store.state.core.featuresStatus.brightness = 0
                }

                if (this.$store.state.core.featuresStatus.brightness === 1) {
                    this.$emit('countAnalytics', this.data._id)
                }
              localStorage.setItem('featuresStatus', JSON.stringify(this.$store.state.core.featuresStatus))
            }
        },
        computed: {
            brightnessLevel () {
                return [
                    {
                        icon: icons.normalColors,
                        value: 'normal',
                        name: this.$t('normal'),
                        step: 0
                    },
                    {
                        icon: icons.invertColors,
                        value: 'black-brightness',
                        name: this.$t('invert colors'),
                        step: 1
                    },
                    {
                        icon: icons.grayLevel,
                        value: 'gray-brightness',
                        name: this.$t('gray level'),
                        step: 2
                    }
                ]
            }
        }
    }
</script>

<style >
    .theme--light.v-application {
        background: transparent;
    }

</style>
